import React from "react";
import TeamIcon from "@components/icons/TeamIcon";
import { TSuggestedEventTeam } from "@data-types/suggested-search/TSuggestedEventTeam";

export const SuggestedEventTeamDisplay = (props: {
	t1: TSuggestedEventTeam;
	t2: TSuggestedEventTeam;
	tournament: { showCountryFlag: boolean };
}) => <div className="popup--search__team">{props.t1.name}</div>;
